
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ResolvedDataUnion": [
      "MediaItem",
      "Product",
      "TaxonomyItem"
    ]
  }
};
      export default result;
    